import React, {Component} from 'react'
import { Route } from "react-router-dom";
import Parse from 'parse';
import Header from "./components/header";
import Login from "./login";
import Search from "./search";
import Units from "./units";
import EditUnit from "./editUnit";
import NewUnit from "./newUnit";


export default class App extends Component {
  constructor() {
      super();
      this.state = {
          isAuthenticated:false
      };
  }

  isAuthenticated = () => {
    this.setState({isAuthenticated:true})
  }
  componentWillMount = () => {
    if(Parse.User.current()){
      this.setState({isAuthenticated:true})
    }
  }
  logOutUser = () =>{
    Parse.User.logOut()
    this.setState({isAuthenticated:false})
  }
  componentDidMount = () =>{

  }
  render() {
    if(!this.state.isAuthenticated) return <Login isAuthenticated={this.isAuthenticated.bind(this)}/>
		return (
      <div className="wrapper">
        <Header logOutUser={this.logOutUser} brand={this.state.brand} />
				<Route
					render={({ location }) => (
            <div id="content" className="light-grey-background small-padding">
              <Route exact path="/" render={props => (<Search logOutUser={this.logOutUser} />)} />
              <Route exact path="/units" render={props => (<Units {...props} logOutUser={this.logOutUser} />)} />
              <Route exact path="/newUnit" render={props => (<NewUnit />)} />
              <Route exact path="/editUnit" render={props => (<EditUnit {...props} />)} />
            </div>
					)}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app.js